import React, { useEffect, useState, useRef } from "react";
import { Link } from "@reach/router";
import { Button } from "reactstrap";
import SuccessImage from "images/success_icon.png";
import { handleError } from "appRedux/actions/Common";
import { SUCCESSFUL_CODE } from "appRedux/constants";
import { config } from "constants/config";
import Loader from "components/Loader";
import { useTheme } from "context/themeContext";
import moment from "moment";
import DOMPurify from "dompurify";
import { useOperatorNavigate } from "utils/navigationHelper";
import { redirectDashboard } from "routes/RedirectRoutes";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  DownloadOutlined,
  FilePdfOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { Tooltip, Button as AntdButton } from "antd";
import api from "appRedux/api";

const Message = () => {
  const [loading, setLoading] = useState(false);
  const { colorTheme, logoUrl, whiteLabelName } = useTheme();
  const [tokenDetails, setTokenDetails] = useState({});
  const [merchantCode, setMarchantCode] = useState("");
  const [reference, setReference] = useState("");

  const ticketRef = useRef(null); // Ref to capture the ticket content
  const navigate = useOperatorNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const trxRef = queryParams.get("trxRef");
    const merchantId = queryParams.get("merchantId");
    setReference(trxRef);
    setMarchantCode(merchantId);
    fetchTokenData(trxRef, merchantId);
  }, []);

  const navigateTransaction = () => {
    navigate("/transactions/email");
  };

  // const fetchTokenData = async (reference, merchantCode, retries = 1) => {
  //   try {
  //     setLoading(true);

  //     const payload = {
  //       transactionReference: reference,
  //       merchantCode: merchantCode,
  //     };

  //     const url = `${config.tokenUrl}/tvp/token/whitelist/generate`;

  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     const data = await response.json();

  //     if (!response.ok) {
  //       const errorMsg = data?.message || `HTTP Error: ${response.status}`;
  //       throw new Error(errorMsg);
  //     }

  //     if (data.status && data.statusCode === SUCCESSFUL_CODE) {
  //       setTokenDetails(data.data);
  //     } else {
  //       throw new Error(data.message || "Token generation failed");
  //     }
  //   } catch (error) {
  //     console.error("Token fetch error:", error);

  //     if (retries > 0) {
  //       handleError(
  //         `Token generation failed, ${error}. Retrying in 30 seconds... (${retries} retries left)`
  //       );
  //       setTimeout(
  //         () => fetchTokenData(reference, merchantCode, retries - 1),
  //         30000
  //       );
  //     } else {
  //       setLoading(false);
  //       handleError(error.message || "Network Error after multiple attempts");
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchTokenData = async (reference, merchantCode, retries = 1) => {
    try {
      setLoading(true);
  
      const payload = {
        transactionReference: reference,
        merchantCode: merchantCode,
      };
  
      const response = await api.post(
        `/tvp/token/whitelist/generate`,
        payload,
        config.tokenUrl // secure baseURL
      );
  
      const data = response?.data;
  
      if (!response || !data) {
        throw new Error("No response from token service");
      }
  
      if (data.status && data.statusCode === SUCCESSFUL_CODE) {
        setTokenDetails(data.data);
      } else {
        throw new Error(data.message || "Token generation failed");
      }
    } catch (error) {
      console.error("Token fetch error:", error);
  
      if (retries > 0) {
        handleError(
          `Token generation failed, ${error.message}. Retrying in 30 seconds... (${retries} retries left)`
        );
        setTimeout(
          () => fetchTokenData(reference, merchantCode, retries - 1),
          30000
        );
      } else {
        handleError(error.message || "Network Error after multiple attempts");
        setLoading(false);
      }
    } finally {
      setLoading(false);
    }
  };
 
  const downloadAsImage = async () => {
    if (!ticketRef.current) return;

    const canvas = await html2canvas(ticketRef.current);
    const image = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = image;
    link.download = `ticket_${tokenDetails?.token || "download"}.png`;
    link.click();
  };

  const downloadAsPDF = async () => {
    if (!ticketRef.current) return;

    const canvas = await html2canvas(ticketRef.current);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`ticket_${tokenDetails?.token || "download"}.pdf`);
  };

  return (
    <div className="main-section">
      <div style={{ marginBottom: "4rem" }} className="topBar">
        <img
          src={DOMPurify.sanitize(logoUrl)}
          alt={`${whiteLabelName} logo`}
          style={{
            width: "80px",
            height: "auto",
            objectFit: "fit",
            maxHeight: "80px",
          }}
        />
        <div
          onClick={redirectDashboard}
          style={{ color: colorTheme, cursor: "pointer" }}
        >
          Go Home
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div
          style={{
            width: "360px",
            alignSelf: "center",
            background: "white",
            padding: "3% 2%",
            borderRadius: "8px",
          }}
        >
          {tokenDetails?.token?.length > 1 ? (
            <>
              <div ref={ticketRef}>
                <div
                  className="email-card__image"
                  style={{ marginBottom: "30px", marginTop: "30px" }}
                >
                  <center>
                    <img src={SuccessImage} alt="Email icon" />
                  </center>
                </div>
                <h3 className="email-card__header">Payment Successful</h3>
                <h4 className="email-card__subheader">
                  Ticket Generated and Saved.
                </h4>
                {tokenDetails?.passengers?.map((passenger, index) => (
                  <center key={index}>
                    <h6 className="email-card__subheader">
                      {passenger.passengerName}: <b>{passenger.token}</b> {passenger.seatNumber?.length > 1 ? `Seat Number: ${passenger.seatNumber}` : null}
                    </h6>
                  </center>
                ))}

                <center>
                  <h6
                    className="email-card__subheader"
                    style={{ marginBottom: "20px" }}
                  >
                    Expires: {moment(tokenDetails.expiryDate).format("LLLL")}
                  </h6>
                </center>
                <center>
                  <h6
                    className="email-card__subheader"
                    style={{ marginBottom: "20px" }}
                  >
                    Route: {tokenDetails?.route}
                  </h6>
                </center>
                <center>
                  <h6
                    className="email-card__subheader"
                    style={{ marginBottom: "20px" }}
                  >
                    Departure Terminal: {tokenDetails?.address}
                  </h6>
                </center>
              </div>
              <div
                className="d-flex justify-content-center"
                style={{ gap: "24px", margin: "1rem 0" }}
              >
                {/* PDF Download */}
                <div
                  className="d-flex flex-column align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={downloadAsPDF}
                >
                  <Tooltip title="Download PDF">
                    <FilePdfOutlined
                      style={{
                        color: colorTheme,
                        fontSize: "24px",
                        marginBottom: "8px",
                      }}
                    />
                  </Tooltip>
                  <span style={{ color: colorTheme }}>Download as pdf</span>
                </div>

                {/* Image Download */}
                <div
                  className="d-flex flex-column align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={downloadAsImage}
                >
                  <Tooltip title="Download Image">
                    <PictureOutlined
                      style={{
                        color: colorTheme,
                        fontSize: "24px",
                        marginBottom: "8px",
                      }}
                    />
                  </Tooltip>
                  <span style={{ color: colorTheme }}>
                    Download as png/jpeg
                  </span>
                </div>
              </div>

              <Button
                onClick={navigateTransaction}
                className="secondary-btn"
                style={{ background: colorTheme, width: "100%" }}
              >
                Transaction history
              </Button>

              <Button
                block
                className=""
                onClick={redirectDashboard}
                color="link"
                style={{ marginTop: "10px", color: colorTheme }}
              >
                Return to Dashboard
              </Button>
            </>
          ) : (
            <div style={{ marginBottom: "20px", marginTop: "20px" }}>
              <h4
                className="email-card__subheader"
                style={{ color: "red", marginBottom: "20px" }}
              >
                Ticket Generation Failed ⚠
              </h4>
              <Button
                block
                className="secondary-btn"
                style={{ background: colorTheme }}
                onClick={() => fetchTokenData(reference, merchantCode)}
              >
                Retry Generating Ticket
              </Button>
              <Button
                onClick={redirectDashboard}
                className=""
                color="link"
                style={{ marginTop: "10px", color: colorTheme }}
              >
                Return to Dashboard
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Message;
